import { UseMutateAsyncFunction } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { getNetworkElementConfigurationTimestamps } from '@api/manageNetworkElementConfigurations';

import { formatAvailableTimestamps } from '@components/routes/AdminPanel/ManageNetworkElementConfigurations/utils';

import { TSelectOption } from '@interfaces/components/componentTypes';
import {
	INetworkElementConfigurationsByDateDTO,
} from '@interfaces/networkElementConfigurations/dto/networkElementConfigurationsDTO';

import { NETWORK_ELEMENT_CONFIGURATION_TIMESTAMPS } from '@constants/queryKeys';

interface IUseQueryNetworkElementConfigurationTimestampsReturned {
	networkElementConfigurationTimestamps: TSelectOption<number>[];
	isLoadingNetworkElementConfigurationTimestamps: boolean;
	getNetworkElementConfigurationTimestamps: UseMutateAsyncFunction<
		any, any, INetworkElementConfigurationsByDateDTO, any
	>;
}

const useMutateNetworkElementConfigurationTimestamps = (): IUseQueryNetworkElementConfigurationTimestampsReturned => {
	const {
		isLoading,
		mutateAsync,
		data,
	} = useMutation<INetworkElementConfigurationsByDateDTO>({
		mutationKey: [NETWORK_ELEMENT_CONFIGURATION_TIMESTAMPS],
		mutationFn: getNetworkElementConfigurationTimestamps,
	});

	return {
		networkElementConfigurationTimestamps: formatAvailableTimestamps(data),
		getNetworkElementConfigurationTimestamps: mutateAsync,
		isLoadingNetworkElementConfigurationTimestamps: isLoading,
	};
};

export default useMutateNetworkElementConfigurationTimestamps;
